import { Card, CardBody, Col } from "reactstrap";
import { JavaModeHeading } from "../../../../Utils/Constants";
import { typeScriptData } from "../../../../Data/Editor/Editor";
import { Highlight, themes } from "prism-react-renderer";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";

const JavaMode = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={JavaModeHeading} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={typeScriptData} language="java">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JavaMode;
